// 对图片url补全http或https协议 & 对fds的图片做优化处理
import { formatFDSImageWebp } from '@/utils/webp'
import { getLocation } from '@/utils/ssrCompatible'

export function formatImgUrl(url) {
  if (!process.client) {
    return url
  }
  const { protocol } = getLocation() || {}
  if (!url) return
  let curUrl = url
  // 反馈图片
  if (url.indexOf('http:') === -1 && url.indexOf('https:') === -1) {
    curUrl = `${protocol}//${url}`
  }
  return formatFDSImageWebp(curUrl)
}
